export const getLogo = (): string | null => {
    const base = process.env.NODE_ENV === 'production' ? '.' : '';
    const logoApp = process.env.LOGO_APP;
    const currentTheme = process.env.CLIENT_LOCALES;

    if (logoApp === 'impersonality') return null;
    if (logoApp === 'smartex') return `${base}/static/logo.svg`;
    if (logoApp === 'otbasy') return `${base}/static/otbasy/logo.svg`;

    return `${base}/static/${currentTheme}/logo.svg`;
};
